"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ClipboardArrowUpSolid: function() {
        return ClipboardArrowUpSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ClipboardArrowUpSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.79289 1.79289C8.30057 1.28521 8.98914 1 9.70711 1H14.2929C15.0109 1 15.6994 1.28521 16.2071 1.79289C16.5444 2.13022 16.7835 2.5474 16.906 3H18C19.6569 3 21 4.34315 21 6V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V6C3 4.34315 4.34315 3 6 3H7.09397C7.21646 2.5474 7.45557 2.13022 7.79289 1.79289ZM14.7929 3.20711C14.9255 3.33972 15 3.51957 15 3.70711V5H9V3.70711C9 3.51957 9.0745 3.33972 9.20711 3.20711C9.33972 3.0745 9.51957 3 9.70711 3H14.2929C14.4804 3 14.6603 3.0745 14.7929 3.20711ZM12.7005 10.2864C12.6062 10.1937 12.498 10.1236 12.3828 10.0759C12.2657 10.0273 12.1375 10.0004 12.003 10L12 10L11.997 10C11.7254 10.0008 11.4792 10.1099 11.2995 10.2864L11.2922 10.2936L9.29289 12.2929C8.90237 12.6834 8.90237 13.3166 9.29289 13.7071C9.68342 14.0976 10.3166 14.0976 10.7071 13.7071L11 13.4142V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V13.4142L13.2929 13.7071C13.6834 14.0976 14.3166 14.0976 14.7071 13.7071C15.0976 13.3166 15.0976 12.6834 14.7071 12.2929L12.7078 10.2936L12.7005 10.2864Z",
        fill: "currentColor"
    })
}), "ClipboardArrowUpSolid");
const _default = ClipboardArrowUpSolid;
